export const getTranslationKeyForNotAvailable = shortVersion =>
    shortVersion
        ? 'shipping-time-not-available-short'

    : 'shipping-time-not-available';
